module.exports = __webpack_public_path__ + "images/namvhd_small2d43a531a71554c0bfdd8c68ff6b08cf.png";